export default {
  headText:
    "Heilen ist eine Frage der Zeit, mitunter aber auch eine Frage der Möglichkeit.",
  headSubtext: "Hippokrates von Kós",
};
